<script>
  import { _ } from "../../services/i18n";
</script>

<section class="section-elements">
  <table class="table-elements">
    <tr>
      <td class="box-elements" id="r-box">
        <a href="#/tuto?/compositor/composition/view">
          <h5>{$_("tutorial_composition_view")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/eye2.svg" alt="eye" />
        </a>
      </td>
      <td class="box-elements" id="y-box">
        <a href="#/tuto?/compositor/composition/search">
          <h5>{$_("tutorial_composition_search")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/search.svg" alt="search" />
        </a>
      </td>
    </tr>
    <tr>
      <td class="box-elements" id="g-box">
        <a href="#/tuto?/compositor/composition/info">
          <h5>{$_("tutorial_composition_info")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/info-circle.svg" alt="info" />
        </a>
      </td>

      <td class="box-elements" id="d-box">
        <a href="#/tuto?/compositor/composition/presets">
          <h5>{$_("tutorial_composition_presets")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/add-fav-sim3d-white.svg" alt="add" />
        </a>
      </td>
    </tr>
    <tr>
      <td class="box-elements" id="b-box">
        <a href="#/tuto?/compositor/composition/tools">
          <h5>{$_("tutorial_composition_tools")}</h5>
          <div class="info-elements">
            <p>Saber más</p>
            <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-elements" src="/icons/tools.svg" alt="pencil" />
        </a>
      </td>
    </tr>
  </table>
</section>


